import React from 'react';
// used for making the prop types of this component
import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';
// core components
import { setViewIsDirty } from '@features/ux/uxSlice';
import {
  ThemedPrimaryBtn,
  ThemedSecondaryBtn,
} from '@themes/defaultThemeProps';
import defaultImage from 'assets/img/image_placeholder.jpg';
import defaultAvatar from 'assets/img/placeholder.jpg';
import { useDispatch } from 'react-redux';
import imageUploadStyle from './imageUploadStyle';
const useStyles = makeStyles(imageUploadStyle);
export default function ImageUpload(props) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [file, setFile] = React.useState(null);
  let {
    image,
    avatar,
    addButtonProps,
    changeButtonProps,
    removeButtonProps,
    getImageFile,
    onRemoveImageFile,
  } = props;
  const [imagePreviewUrl, setImagePreviewUrl] = React.useState(
    image ? image : avatar ? defaultAvatar : defaultImage
  );
  let fileInput = React.createRef();
  const handleImageChange = (e) => {
    e.preventDefault();
    dispatch(setViewIsDirty(true));
    let reader = new FileReader();
    let file = e.target.files[0];
    reader.onloadend = () => {
      setFile(file);
      setImagePreviewUrl(reader.result);
      getImageFile(file); // pass image file back up to caller
    };
    if (file) {
      reader.readAsDataURL(file);
    }
  };
  const handleClick = () => {
    fileInput.current.click();
  };
  const handleRemove = () => {
    setFile(null);
    dispatch(setViewIsDirty(true));
    setImagePreviewUrl(avatar ? defaultAvatar : defaultImage);
    fileInput.current.value = null;

    if (onRemoveImageFile) onRemoveImageFile();
  };
  return (
    <div className='fileinput text-center'>
      <input type='file' onChange={handleImageChange} ref={fileInput} />
      <div className={'thumbnail' + (avatar ? ' img-circle' : '')}>
        <img src={imagePreviewUrl} alt='...' />
      </div>
      <div>
        {file === null && image === null ? (
          <ThemedPrimaryBtn {...addButtonProps} onClick={() => handleClick()}>
            {avatar ? 'Add Photo' : 'Select Image'}
          </ThemedPrimaryBtn>
        ) : (
          <div className={classes.buttonContainer}>
            <ThemedPrimaryBtn
              {...changeButtonProps}
              onClick={() => handleClick()}
            >
              Change
            </ThemedPrimaryBtn>
            {avatar ? <br /> : null}
            <ThemedSecondaryBtn
              {...removeButtonProps}
              onClick={() => handleRemove()}
            >
              <i className='fas fa-times' /> Remove
            </ThemedSecondaryBtn>
          </div>
        )}
      </div>
    </div>
  );
}

ImageUpload.propTypes = {
  image: PropTypes.string,
  avatar: PropTypes.bool,
  addButtonProps: PropTypes.object,
  changeButtonProps: PropTypes.object,
  removeButtonProps: PropTypes.object,
  getImageFile: PropTypes.func,
};
